import React from "react";
import "./ApostilleWhat.css";
const ApostilleWhat = () => {
  return (
    <div className="apostilleWhatContainer">
      <h2>
        What is an <span>Apostille</span> ?
      </h2>
      <p>
        An apostille is a certificate issued by a designated authority that
        authenticates the origin of a public document. In the case of degree
        certificates, it verifies that the document is genuine and has been
        issued by a recognized educational institution. The apostille makes the
        degree certificate legally acceptable in all countries that are members
        of the Hague Apostille Convention.
      </p>
    </div>
  );
};

export default ApostilleWhat;
